<template>
  <section
    class="form-block">
    <!-- errors -->
    <div
      v-if="errors && errors.length > 0"
      class="form-block__errors">
      <p
        v-for="(error, key) in errors"
        :key="`error${key}`"
        v-html="error"/>
    </div>

    <!-- form -->
    <form
      v-if="!isSubmitted"
      :class="{
        'form--submitting': submitting,
        'form--submitted': isSubmitted
      }"
      class="form-block__form form"
      @submit.prevent="submitForm">
      <div class="form__row">
        <h3>Ask a question or provide feedback to Molonglo</h3>
        <TextField
          required
          name="first_name"
          placeholder="First name..."/>
        <TextField
          required
          name="last_name"
          placeholder="Last name..."/>
        <TextField
          required
          type="email"
          name="email"
          placeholder="Email..."/>
        <TextField
          required
          type="tel"
          name="postcode"
          placeholder="Postcode..."/>
        <TextareaField
          :disabled="submitting"
          :name="'feedback'"
          :required="true"
          placeholder="Type here..."
          :valid="false"/>
      </div>

      <input
        class="form-block__submit"
        type="submit"
        value="Submit"
        :disabled="submitting">
    </form>

    <!-- success ~ form submitted -->
    <div
      v-if="isValid && isSubmitted && !submitting"
      class="form-block__success">
      <h3>
        Thanks for the feedback.
      </h3>
    </div>
  </section>
</template>

<script>
import TextareaField from '@/components/base/form/TextareaField'
import TextField from './form/TextField'

export default {
  name: 'FormBlock',
  components: {
    TextField,
    TextareaField,
  },
  data() {
    return {
      errors: [],
      isSubmitted: false,
      isValid: false,
      submitting: false,
      formkeepID: 'e1b5949545a3',
      formkeepUrl: 'https://formkeep.com/f/e1b5949545a3'
    }
  },
  methods: {
    async submitForm() {
      if (this.validateForm()) {
        const formComponents = this.$children
        const form = new FormData

        this.submitting = true

        formComponents.forEach(formComponent => {
          switch (formComponent.type) {
            case 'text' :
            case 'email' :
            case 'tel' :
              form.append(formComponent.name, formComponent.text)
              break

            case 'textarea' :
              form.append(formComponent.name, formComponent.textarea)
              break

            case 'radio' :
              form.append(formComponent.name, formComponent.checked)
              break
          }
        })

        await this.submitToFormkeep(form)

        setTimeout(() => {
          this.submitting = false
          this.isValid = true
          this.isSubmitted = true
        }, 500)
      }
    },
    validateForm() {
      return true
    },
    submitToFormkeep(form) {
      return new Promise(resolve => {
        fetch(this.formkeepUrl, {
          method: 'POST',
          body: form
        }).then(response => response.json()).then(result => {
          if (typeof result === typeof null) {
            resolve(true)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-block {
  .form {
    width: 100%;

    &--submitting {
      position: relative;

      &,
      .form-block__submit {
        cursor: wait;
      }
    }

    &__row {
      h3 {
        margin: #{$padding * 3} 0 10px 0;
      }
    }
  }

  &__title {
    margin: 0 0 #{$padding * 5} 0 !important;
  }

  &__submit {
    @include button-resets;
    color: $black;
    font-size: $body;
    padding: 10px 24px;
    border: 3px solid $black;

    &:hover {
      color: $white;
      background-color: $black;
    }
  }

  &__success {
    margin: #{$padding * 5} 0 #{$padding * 5} 0;
  }
}
</style>
